import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ROLES } from '../../model/roles';
import { ACTION_TYPES } from '../../model/actions';

// Import dei componenti e degli hook necessari
import useAgenzie from '../../hooks/useAgenzie';
import useSconti from '../../hooks/useSconti';
import useVoucher from '../../hooks/useVoucher';
import CustomTable from '../../components/CustomTable/CustomTable';
import CustomModal from '../../components/CustomModal/CustomModal';
import CreateAgenziaForm from '../../components/Forms/CreateAgenziaForm/CreateAgenziaForm';
import AssegnaScontoManager from '../../components/AssegnaScontoManager/AssegnaScontoManager';
import GestisciVoucherManager from '../../components/GestisciVoucherManager/GestisciVoucherManager';
import AgenziaInfo from '../../components/AgenziaInfo/AgenziaInfo';
import CustomFilterTable from '../../components/CustomFilterTable/CustomFilterTable';
import CustomPagination from '../../components/CustomPagination/CustomPagination';
import LoadingTable from '../../components/LoadingTable/LoadingTable';
import useAgenziaConfigTable from '../../configTable/useAgenziaConfigTable';
import useMediaQuery from '../../hooks/useMediaQuery';
import UtilityService from '../../services/UtillityServices/UtilityService';
import { alertService } from '../../services/AlertService';
import DistribuzioneVoucherSP from '../../components/DistribuzioneVoucherSP/DistribuzioneVoucherSP';

const GestioneAgenziePage = () => {
    const { getAgenzieByParams, loadingStateAgenzie, createAgenzia, deleteAgenzia, modalStateAgenzie, setModalStateAgenzie, updateAgenzia } = useAgenzie();
    
    // Dichiarazione di tutti gli stati e hook necessari all'inizio
    const userLoggedIn = useSelector(state => state.user.userData);
    const { modalStateSconti, setModalStateSconti } = useSconti();
    const { modalStateVoucher, setModalStateVoucher } = useVoucher();
    
    const isWideScreen = useMediaQuery('(min-width: 1200px)');
    const [agenzie, setAgenzie] = useState([]);
    const [selectedAgenzia, setSelectedAgenzia] = useState(null);
    const [formCreateAgenzia, setFormCreateAgenzia] = useState({});
    const [orderBy, setOrderBy] = useState(null);
    const [orderType, setOrderType] = useState(null);
    const [selectedPage, setSelectedPage] = useState(1); 
    const [formDataFilter, setFormDataFilter] = useState({});
    const [totalPages, setTotalPages] = useState(1);
    const [isLoadingAgenzie, setIsLoadingAgenzie] = useState(false);
    const [showDistribuzioneModal, setShowDistribuzioneModal] = useState(false);
    const agenziaConfigTable = useAgenziaConfigTable();

    useEffect(() => {
        if (!isLoadingAgenzie) {
            printAllAgenzie();
        }
    }, [orderBy, orderType, selectedPage]);
    
    const fetchAgenzie = async (obj) => {
        setIsLoadingAgenzie(true);
        const fetchAgenzieList = await getAgenzieByParams(obj);
        const countPagination = Math.ceil(fetchAgenzieList?.count / obj.limite);
        let agenzieList = fetchAgenzieList?.data ?? [];
        setTotalPages(countPagination);
        setAgenzie(agenzieList);
        setIsLoadingAgenzie(false);
    };
    
    const printAllAgenzie = async () => {
        let obj = {
            filtri: { ...formDataFilter },
            limite: 10,
            pagina: selectedPage ?? 1,
            ordinamento: `${orderBy ?? "denominazione"} ${orderType ?? "asc"}`
        };
        await fetchAgenzie(obj);
    };
    
    const onFilteredTable = async () => {
        setSelectedPage(1);
        let obj = {
            filtri: { ...formDataFilter },
            limite: 10,
            pagina: 1,
            ordinamento: `${orderBy ?? "denominazione"} ${orderType ?? "asc"}`
        };
        await fetchAgenzie(obj);
    };

    const handleCloseModal = () => {
        setModalStateAgenzie({ showModalCreateAgenzia: false, showModalInfoAgenzia: false, showModalDeleteAgenzia: false, showModalUpdateAgenzia: false });
        setModalStateSconti({ showModalCreateSconto: false });
        setModalStateVoucher({ showModalGestisciVoucher: false });
        setSelectedAgenzia(null);
        setFormCreateAgenzia({});
    };

    const openAssegnaScontiModal = (agenzia) => {
        setSelectedAgenzia(agenzia);
        setModalStateSconti(state => ({ ...state, showModalCreateSconto: true }));
    };

    const openGestisciVoucherModal = (agenzia) => {
        setSelectedAgenzia(agenzia);
        setModalStateVoucher(state => ({ ...state, showModalGestisciVoucher: true }));
    };

    const openDistribuisciVoucherModal = (agenzia) => {
         console.log("DEBUG PASSO 1 (Pagina): Cliccato 'Distribuisci Voucher'. Apro modale per agenzia:", agenzia);
        setSelectedAgenzia(agenzia);
        setShowDistribuzioneModal(true);
    };
    const openInfoModal = (agenzia) => { setSelectedAgenzia(agenzia); setModalStateAgenzie(state => ({ ...state, showModalInfoAgenzia: true })); };
    const openEditModal = (agenzia) => { setSelectedAgenzia(agenzia); setFormCreateAgenzia(agenzia); setModalStateAgenzie(state => ({ ...state, showModalUpdateAgenzia: true })); };
    const openDeleteModal = (agenzia) => { setSelectedAgenzia(agenzia); setModalStateAgenzie(state => ({ ...state, showModalDeleteAgenzia: true })); };
    const openModalCreateAgenzia = () => { setModalStateAgenzie(state => ({ ...state, showModalCreateAgenzia: true })); };
    
    const onCreateAgenzia = async () => {
        const requiredFields = ["denominazione", "indirizzo", "cap", "citta", "provincia", "piva"];
        const missingFields = UtilityService.validationForm(formCreateAgenzia, requiredFields);
        if (missingFields?.length > 0) {
            alertService.warn(`I seguenti campi sono obbligatori: ${missingFields.join(", ")}`, {autoClose: true});
            return;
        }
        const res = await createAgenzia(formCreateAgenzia);
        if(res) { printAllAgenzie(); handleCloseModal(); }
    };

    const onDeleteAgenzia = async () => {
        const res = await deleteAgenzia({id_agenzia: selectedAgenzia?.id_agenzia});
        if(res) { printAllAgenzie(); handleCloseModal(); }
    };

    const onUpdateAgenzia = async () => {
        const res = await updateAgenzia({ ...formCreateAgenzia, id_agenzia: selectedAgenzia?.id_agenzia });
        if(res) { printAllAgenzie(); handleCloseModal(); }
    };
    
    const handleOrder = (orderBy, orderType) => { setOrderBy(orderBy); setOrderType(orderType); };
    const handlePageChange = (page) => { setSelectedPage(page); };
    
    const renderSelectedDeleteAgenzia = () => (
        <span className="fs-5" style={{wordBreak: "break-word"}}>Vuoi eliminare l'agenzia "<b>{selectedAgenzia?.denominazione}</b>"?</span>
    );
    
    const actions = [
        { 
            label: ACTION_TYPES.DETAILS,
            type: ACTION_TYPES.CONFIG, 
            icon: 'bi-info-circle text-dark', 
            onClick: openInfoModal 
        },
        {
            label: "Assegna Sconti",
            icon: 'bi-percent text-dark',
            type: ACTION_TYPES.MANAGER,
            // Visibile sia all'Admin che al Superpartner
            condition: () => userLoggedIn.role === ROLES.ADMIN || userLoggedIn.role === ROLES.DEVELOPER || userLoggedIn.role === ROLES.SUPERPARTNER,
            onClick: openAssegnaScontiModal
        },
        {
            label: "Gestisci Voucher",
            icon: 'bi-ticket-perforated-fill text-success',
            type: ACTION_TYPES.MANAGER,
            // Visibile SOLO all'Admin (logica di creazione)
            condition: () => userLoggedIn.role === ROLES.ADMIN || userLoggedIn.role === ROLES.DEVELOPER,
            onClick: openGestisciVoucherModal
        },
        {
            label: "Distribuisci Voucher",
            icon: 'bi-box-arrow-up-right text-primary',
            type: ACTION_TYPES.MANAGER,
            // Visibile SOLO al Superpartner (logica di distribuzione)
            condition: () => userLoggedIn.role === ROLES.SUPERPARTNER,
            onClick: openDistribuisciVoucherModal
        },
        { 
            label: ACTION_TYPES.UPDATE,
            type: ACTION_TYPES.CONFIG, 
            icon: 'bi-pencil-fill text-warning', 
            onClick: openEditModal 
        },
        { 
            label: ACTION_TYPES.DELETE,
            type: ACTION_TYPES.CONFIG, 
            icon: 'bi-trash-fill text-danger', 
            onClick: openDeleteModal 
        }
    ];

    return (
        <>
            <div className={`card custom-card w-100 shadow ${isWideScreen ? 'p-5' : 'px-1 py-3'}`} style={{minHeight: '700px'}}>
                <div className='container'>
                    <div className='d-flex justify-content-between custom-card-header'>
                        <div className='d-flex gap-3 custom-card-title my-2'>
                            <div className={`custom-icon-container`}><i className={`bi custom-icon bi-building fs-2`}></i></div>
                            <div className='align-self-center'><span className='fs-4 d-block'><i><b>Gestione agenzie</b></i></span></div>
                        </div>
                        <div className='align-self-center my-2'><button type='button' className='btn btn-primary' onClick={openModalCreateAgenzia}>Crea agenzia</button></div>
                    </div>
                    <div className='mt-5'>
                        <CustomFilterTable 
                            formDataFilter={formDataFilter} setFormDataFilter={setFormDataFilter} onFilteredTable={onFilteredTable}
                            isLoadingData={loadingStateAgenzie.isLoadingAgenzieByParams}
                            searchNodeType={[ {nodeType: "input", name: "denominazione", placeholder: "ragione sociale"}, {nodeType: "input", name: "piva", placeholder: "partita iva"} ]}
                        />
                    </div>
                    {!loadingStateAgenzie.isLoadingAgenzieByParams ? ( 
                        <>
                            {(!agenzie || agenzie?.length === 0) ? (
                                <div className='mt-5 pt-5 text-center'><p>Non ci sono agenzie da mostrare.</p></div>
                            ) : (
                                <>
                                    <CustomTable data={agenzie} actions={actions} columns={agenziaConfigTable} handleOrder={handleOrder} orderBy={orderBy} orderType={orderType}/>
                                    <div className="d-flex justify-content-end mt-1"><CustomPagination totalPages={totalPages} selectedPage={selectedPage} handlePageChange={handlePageChange}/></div>
                                </>
                            )}
                        </>
                    ) : ( <LoadingTable loadingCol={7} /> )}
                </div>
            </div>

            {/* Modali per la gestione delle agenzie */}
            <CustomModal show={modalStateAgenzie.showModalCreateAgenzia} onHide={handleCloseModal} headerText="Crea agenzia" size={"lg"} btnText={"Crea"} body={<CreateAgenziaForm formCreateAgenzia={formCreateAgenzia} setFormCreateAgenzia={setFormCreateAgenzia} showModalCreateAgenzia={modalStateAgenzie.showModalCreateAgenzia}/>} closeButton={true} onUndoChanges={handleCloseModal}  isLoading={loadingStateAgenzie.isLoadingAgenziaCreating} onSave={onCreateAgenzia} />
            <CustomModal show={modalStateAgenzie.showModalUpdateAgenzia} onHide={handleCloseModal} headerText="Modifica agenzia" size={"lg"} btnText={"Salva"} body={<CreateAgenziaForm formCreateAgenzia={formCreateAgenzia} setFormCreateAgenzia={setFormCreateAgenzia} showModalCreateAgenzia={modalStateAgenzie.showModalUpdateAgenzia}/>} closeButton={true} onUndoChanges={handleCloseModal} isLoading={loadingStateAgenzie.isLoadingAgenziaUpdate} onSave={onUpdateAgenzia} />
            <CustomModal show={modalStateAgenzie.showModalDeleteAgenzia} onHide={handleCloseModal} headerText="Elimina agenzia" size={"md"} variant={"danger"} btnText={"Elimina"} body={renderSelectedDeleteAgenzia()} isLoading={loadingStateAgenzie.isLoadingAgenziaDelete} closeButton={true} onUndoChanges={handleCloseModal}  onSave={onDeleteAgenzia} />
            <CustomModal show={modalStateAgenzie.showModalInfoAgenzia} onHide={handleCloseModal} headerText="Informazioni agenzia" size={"lg"} hideSaveBtn={true} btnCancelText="Chiudi" onUndoChanges={handleCloseModal} body={<AgenziaInfo agenziaData={selectedAgenzia} />} />

            {/* Modali per sconti e voucher, renderizzate solo quando un'agenzia è selezionata */}
            {selectedAgenzia && (
                <>
                    <AssegnaScontoManager
                        selectedAgenzia={selectedAgenzia}
                        modalStateSconti={modalStateSconti}
                        onHide={handleCloseModal}
                    />
                    <GestisciVoucherManager
                        selectedAgenzia={selectedAgenzia}
                        modalStateVoucher={modalStateVoucher}
                        onHide={handleCloseModal}
                    />
                    <DistribuzioneVoucherSP
                        show={showDistribuzioneModal}
                        onHide={() => setShowDistribuzioneModal(false)}
                        selectedAgenzia={selectedAgenzia}
                    />
                </>
            )}
        </>
    );
}

export default GestioneAgenziePage;